import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Checkbox,
  TextField,
  IconButton,
  FormControl,
  Menu,
  MenuItem,
  Chip,
  Avatar
} from "@mui/material";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import { grey } from "@mui/material/colors";
import DatePicker from "react-datepicker";

const TaskSection = ({
  ticketData,
  setTicketData,
  raiseTicket,
  fetchChatGPTResponse,
  displayAlertMessage,
  message,
  memberList,
  handleToggleEdit,
}) => {

  const [anchorElAssignMenu, setAnchorElAssignMenu] = useState(null);
  const [anchorElAssignIndex, setAnchorElAssignIndex] = useState(null);

  const handleAssignMenuClick = (event, index) => {
    setAnchorElAssignMenu(event.currentTarget);
    setAnchorElAssignIndex(index);
  };

  const handleCloseAssignMenu = () => {
    setAnchorElAssignMenu(null);
    setAnchorElAssignIndex(null);
  };

  const handleSubtaskChange = (index, value) => {
    const updatedSubtasks = [...ticketData.ticketItems];
    updatedSubtasks[index].description = value; // Update the name of the subtask

    const updatedFormData = {
      ...ticketData,
      ticketItems: updatedSubtasks,
    };
    setTicketData(updatedFormData);
  };

  const handleDeleteSubtaskMember = (memberId, index) => {
    const updatedTicketItems = [...ticketData.ticketItems];
    const currentItem = updatedTicketItems[index];
    const updatedMemberIds = currentItem.memberIds.filter((id) => id !== memberId);

    updatedTicketItems[index] = {
      ...currentItem,
      memberIds: updatedMemberIds,
    };

    const updatedFormData = {
      ...ticketData,
      ticketItems: updatedTicketItems,
    };

    setTicketData(updatedFormData);
    raiseTicket(updatedFormData);
    displayAlertMessage(message.removeMember);
  };

  const taskSave = async (index) => {
    raiseTicket(ticketData);
  }

  const handleSubTaskGeneration = async () => {
    const messageContent = `Generate a subtask list only list i need for "${ticketData.subject}"`;
    const resp = await fetchChatGPTResponse(messageContent);

    const subtasksArray = resp.split("\n").map((subtask) => ({
      description: subtask.trim(),
      dueDate: null,
      member: "",
    }));

    const currentFormData = {
      ...ticketData,
      ticketItems: subtasksArray,
    };
    setTicketData(currentFormData);

    raiseTicket(currentFormData);
  };

  const handleDateChange = (date, index) => {
    const updatedSubtasks = [...ticketData.ticketItems];
    updatedSubtasks[index].dueDate = date; // Update due date for the specific subtask

    const currentFormData = {
      ...ticketData,
      ticketItems: updatedSubtasks,
    };
    setTicketData(currentFormData);
    raiseTicket(currentFormData);
  };

  // Add new subtask
  const handleAddSubtask = () => {
    const currentFormData = {
      ...ticketData,
      ticketItems: [
        ...(ticketData.ticketItems || []),
        { description: "", dueDate: null, memberIds: [] },
      ],
    };
    setTicketData(currentFormData);
  };

  // Remove subtask
  const handleRemoveSubtask = (index) => {
    const updatedSubtasks = ticketData.ticketItems.filter((_, i) => i !== index); // Remove by index
    const currentFormData = {
      ...ticketData,
      ticketItems: updatedSubtasks,
    };
    setTicketData(currentFormData);

    raiseTicket(currentFormData);
  };

  const handleToggleDateEdit = (index, editing) => {
    setTicketData((prev) => {
      const updatedItems = [...prev.ticketItems];
      updatedItems[index] = { ...updatedItems[index], isEditingDate: editing };
      return { ...prev, ticketItems: updatedItems };
    });
  };

  const handleCheckboxChange = (index, isChecked) => {

    const updatedSubtasks = [...ticketData.ticketItems];
    updatedSubtasks[index].isCompleted = isChecked; // Update the name of the subtask

    const updatedFormData = {
      ...ticketData,
      ticketItems: updatedSubtasks,
    };
    setTicketData(updatedFormData);
    raiseTicket(updatedFormData)
    if (isChecked) displayAlertMessage(message.taskCompletedMessage);
    else displayAlertMessage(message.taskInCompletedMessage);
  };

  const handleToggleTicketMember = (memberId, index) => {
    const updatedTicketItems = [...ticketData.ticketItems];
    const currentItem = updatedTicketItems[index];
    const currentMemberIds = currentItem.memberIds || [];

    const updatedItem = {
      ...currentItem,
      memberIds: currentMemberIds.includes(memberId)
        ? currentMemberIds.filter((id) => id !== memberId)
        : [...currentMemberIds, memberId],
    };

    displayAlertMessage(
      currentMemberIds.includes(memberId)
        ? message.removeMember
        : message.addMember
    );

    updatedTicketItems[index] = updatedItem;

    const updatedFormData = {
      ...ticketData,
      ticketItems: updatedTicketItems,
    };

    setTicketData(updatedFormData);
    raiseTicket(updatedFormData);
  };

  return (
    <>
      {/* {ticketData && ticketData.ticketItems && ticketData.ticketItems.length > 0 ? ( */}
      <Box>
        {/* Header Section */}
        <Grid container spacing={1}>
          <Grid item xs={0.2}></Grid>
          <Grid item xs={0.3}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2
              }}
            >
              <TaskAltIcon sx={{ fontSize: 20, mr: 1 }} />
            </Box>
          </Grid>

          <Grid item xs={9}>
            <Typography component="div" variant="body2" color="text.secondary">
              <strong>Task</strong>
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Button
              onClick={handleSubTaskGeneration}
              variant="contained"
              color="primary"
              size="medium"
              sx={{
                fontSize: "14px",
                padding: "6px 16px",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "primary.light"
                }
              }}
            >
              Generate AI
            </Button>
          </Grid>
        </Grid>

        <Divider
          sx={{ borderBottomWidth: 1, borderColor: grey[300], my: 2, width: "100%" }}
        />

        {/* Task Items */}
        <Grid container sx={{ padding: "2px", backgroundColor: "#f9f9f9" }}>
          <Grid container spacing={2}>
            {(ticketData?.ticketItems ?? []).map((subtask, index) => (
              <React.Fragment key={index}>
                {/* Checkbox */}
                <Grid item xs={0.2}></Grid>
                <Grid item xs={0.4}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon />}
                    checkedIcon={<DoneIcon style={{ color: "green" }} />}
                    checked={subtask.completed}
                    onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                  />
                </Grid>

                {/* Task Description */}
                <Grid item xs>
                  {subtask.isEditing ? (
                    <TextField
                      variant="outlined"
                      fullWidth
                      autoFocus
                      value={subtask.description}
                      onChange={(e) => handleSubtaskChange(index, e.target.value)}
                      onBlur={() => {
                        handleToggleEdit(index, false);
                        taskSave();
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0,
                          "& fieldset": {
                            border: "none",
                            borderBottom: "1px solid #C2C2C2"
                          },
                          "&:hover fieldset": {
                            borderBottom: "1px solid #E0E0E0"
                          },
                          "&.Mui-focused fieldset": {
                            borderBottom: "1px solid #C2C2C2"
                          }
                        },
                        "& .MuiInputBase-input": {
                          fontSize: 14
                        }
                      }}
                    />
                  ) : (
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 14,
                        color: subtask.description ? "black" : "#9CA3AF",
                        padding: "6px 8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#f9fafb"
                        }
                      }}
                      onClick={() => handleToggleEdit(index, true)}
                    >
                      {subtask.description || "Enter Task"}
                    </Typography>
                  )}
                </Grid>

                {/* Due Date */}
                <Grid item>
                  {subtask.isEditingDate ? (
                    <DatePicker
                      selected={subtask.dueDate ? new Date(subtask.dueDate) : null}
                      onChange={(date) => {
                        handleDateChange(date, index);
                        handleToggleDateEdit(index, false);
                      }}
                      showTimeSelect
                      timeIntervals={15}
                      dateFormat="dd-MMM-yyyy h:mm aa"
                      customInput={
                        <TextField
                          variant="standard"
                          autoFocus
                          sx={{
                            width: 160,
                            "& .MuiInputBase-input": {
                              fontSize: 13,
                              padding: "4px 0"
                            },
                            "& .MuiInput-underline:before": {
                              borderBottom: "2px solid green"
                            },
                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                              borderBottom: "2px solid darkgreen"
                            },
                            "& .MuiInput-underline:after": {
                              borderBottom: "2px solid green"
                            }
                          }}
                          onBlur={() => handleToggleDateEdit(index, false)}
                        />
                      }
                    />
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: 13,
                        color: subtask.dueDate ? "black" : "#9CA3AF",
                        padding: "6px 8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#f9fafb"
                        }
                      }}
                      onClick={() => handleToggleDateEdit(index, true)}
                    >
                      {subtask.dueDate
                        ? new Intl.DateTimeFormat("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false
                        }).format(new Date(subtask.dueDate))
                        : "Set Due Date"}
                    </Typography>
                  )}
                </Grid>

                {/* Delete Button */}
                <Grid item>
                  <IconButton onClick={() => handleRemoveSubtask(index)}>
                    <DeleteIcon color="error" />
                  </IconButton>
                </Grid>

                {/* Members Section */}
                <Grid container alignItems="center" sx={{ mt: 1 }}>
                  <FormControl>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        borderRadius: "8px",
                        padding: "0px 2px",
                        gap: 1
                      }}
                    >
                      <PersonIcon color="primary" sx={{ ml: 6, fontSize: "24px" }} />

                      {/* Selected Members */}
                      {subtask.memberIds && subtask.memberIds.length > 0 ? (
                        subtask.memberIds.map((memId) => {
                          const member = memberList.find((m) => m.id === memId);
                          return (
                            member && (
                              <Chip
                                key={member.id}
                                color="primary"
                                label={member.fullName}
                                onDelete={() => handleDeleteSubtaskMember(member.id, index)}
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: 500
                                }}
                              />
                            )
                          );
                        })
                      ) : null}

                      {/* Add (+) Icon */}
                      <IconButton
                        size="small"
                        sx={{
                          backgroundColor: "#e3f2fd",
                          color: "#1976d2",
                          borderRadius: "50%",
                          "&:hover": {
                            backgroundColor: "#bbdefb"
                          }
                        }}
                        onClick={(e) => handleAssignMenuClick(e, index)}
                      >
                        <AddIcon />
                      </IconButton>
                    </Box>

                    {/* Member Selection Menu */}
                    <Menu
                      anchorEl={anchorElAssignMenu}
                      open={anchorElAssignIndex === index && Boolean(anchorElAssignMenu)}
                      onClose={handleCloseAssignMenu}
                    >
                      {memberList.length > 0 ? (
                        memberList.map((member) => {
                          const selectedSubtask = ticketData.ticketItems[index];
                          const isSelected = selectedSubtask?.memberIds?.includes(member.id);

                          return (
                            <MenuItem
                              key={member.id}
                              onClick={() => handleToggleTicketMember(member.id, index)}
                              sx={{
                                width: "180px",
                                fontSize: "12px",
                                backgroundColor: isSelected ? "#eff4ff" : "transparent",
                                "&:hover": {
                                  backgroundColor: "#f5f7fa"
                                }
                              }}
                            >
                              <Avatar
                                sx={{
                                  width: 20,
                                  height: 20,
                                  fontSize: "11px",
                                  backgroundColor: "#1976d2",
                                  color: "white",
                                  mr: 1
                                }}
                              >
                                {member.fullName.charAt(0).toUpperCase()}
                              </Avatar>
                              {member.fullName}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem disabled>No Members</MenuItem>
                      )}
                    </Menu>
                  </FormControl>
                </Grid>

                <Divider
                  sx={{ borderBottomWidth: 1, borderColor: grey[300], my: 2, width: "100%" }}
                />
              </React.Fragment>
            ))}

            {/* Add Task Button */}
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                onClick={handleAddSubtask}
                sx={{
                  fontSize: "14px",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    color: "#fff"
                  }
                }}
                size="small"
              >
                Add Task
              </Button>
              <br />
              <br />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* ) : (
        <div></div>
      )} */}
    </>
  );
};

export default TaskSection;
